<template>
  <b-form
    @submit.prevent="handleSubmit"
    :class="`wrapper-form ${wrapperClass}`"
    id="check-scroll"
    @scroll="checkScroll()"
  >
    <div :class="`${bodyClass}`">
      <slot name="default"></slot>
    </div>
    <slot name="footer">
      <div
        v-if="hasFooter"
        class="wrapper-form__footer z-index-1"
        :class="{ 'wrapper-form__sticked-footer': showFooterShadow }"
      >
        <Button
          v-if="hasCloseButton"
          :text="$lang.cancel"
          variant="filled-complementary"
          class="mobile-width-percent-100 margin-left-8"
          contentClass="mobile-flex-justify-content-center"
          @click="handleClose"
        />
        <Button
          v-if="isSubmitButton"
          :text="submitButtonText || $lang.submit"
          variant="primary"
          type="submit"
          class="mobile-width-percent-100"
          contentClass="mobile-flex-justify-content-center"
          :loading="loading"
        />
      </div>
    </slot>
  </b-form>
</template>

<script>
import { ref, toRefs } from "vue";
import Button from "../button/Button.vue";
export default {
  components: { Button },
  props: {
    handleSubmit: {
      type: Function,
      default: () => {},
    },
    handleClose: {
      type: Function,
      default: () => {},
    },
    hasCloseButton: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    wrapperClass: {
      type: String,
      default: "height--max-content",
    },
    bodyClass: {
      type: String,
      default: "padding-x-16 padding-top-24",
    },
    isSubmitButton: {
      type: Boolean,
      default: true,
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
    submitButtonText: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // generate props data
    const { handleSubmit, handleClose, hasCloseButton } = toRefs(props);

    const showFooterShadow = ref(false);
    const checkScroll = () => {
      const el = document.getElementById("check-scroll");
      const calcScroll = el.scrollHeight - el.scrollTop;
      showFooterShadow.value = calcScroll > el.clientHeight;
    };

    // return data to be used in template
    return {
      handleSubmit,
      handleClose,
      hasCloseButton,
      showFooterShadow,
      checkScroll,
    };
  },
};
</script>
